import React, { useState, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import NotificationDropdown from "../notificathion/NotificationDropdown";
import MobileHeader from "./MobileHeader";
import { selectBellNotificationCount } from "../../redux/slices/bellNotificationSlice";

const Header = () => {
  const location = useLocation();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const bellRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);
  const [email, setEmail] = useState("");
  const unreadCount = useSelector(selectBellNotificationCount);

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    if (userData?.email) {
      setEmail(userData.email);
    }
  }, []);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 1028);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const formatPathname = (pathname) => {
    const translatedKey = [
      { en: "dashboard", am: "Գլխավոր էջ" },
      { en: "services", am: "Ծառայություններ" },
      { en: "orders", am: "Պատվերներ" },
      { en: "statistics", am: "Վիճակագրություն" },
      { en: "settings", am: "Կարգավորումներ" },
    ];

    // Remove leading slashes
    const formattedPath = pathname.replace(/^\/+/, ""); // Remove leading slashes

    // Find the matching key and return the Armenian translation
    const match = translatedKey.find(
      (key) => key.en === formattedPath.toLowerCase()
    );

    return match
      ? match.am
      : formattedPath
      ? "Էջը չի գտնվել" // Display this when the key is not found
      : "Գլխավոր"; // Optional: handle empty paths
  };

  const toggleDropdown = (e) => {
    setDropdownOpen(!dropdownOpen);
  };

  return (
    <>
      {isMobile ? (
        <MobileHeader email={email} formatPathname={formatPathname} />
      ) : (
        <>
          <header className=" mt-10 mb-5 py-2.5 px-6 w-full shadow-lg rounded-3xl flex  justify-between">
            <h1 className="prose-t24_bold  text-primary tracking-wider">
              {formatPathname(location.pathname)}
            </h1>
            <div className="flex gap-4">
              <div className="relative" ref={bellRef}>
                <svg
                  onClick={toggleDropdown}
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="cursor-pointer"
                >
                  <path
                    d="M15 17H20L18.5951 15.5951C18.2141 15.2141 18 14.6973 18 14.1585V11C18 8.38757 16.3304 6.16509 14 5.34142V5C14 3.89543 13.1046 3 12 3C10.8954 3 10 3.89543 10 5V5.34142C7.66962 6.16509 6 8.38757 6 11V14.1585C6 14.6973 5.78595 15.2141 5.40493 15.5951L4 17H9M15 17V18C15 19.6569 13.6569 21 12 21C10.3431 21 9 19.6569 9 18V17M15 17H9"
                    stroke="#181F46"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <div className="px-1 bg-primary rounded-full text-center text-white prose-t11_regular absolute -top-2 -end-1">
                  {unreadCount === 0 ? null : unreadCount}
                  <div className="absolute top-0 start-0 rounded-full -z-10 animate-ping bg-primary w-full h-full"></div>
                </div>
              </div>

              {/* Render dropdown if open */}
              <div className="flex gap-2.5 pr-2">
                <span className="prose-t14_regular text-midnightBlue block whitespace-nowrap overflow-hidden overflow-ellipsis max-w-[100px] lg:max-w-[150px]">
                  {email || "Էլ․ փոստը բացակայում է"}
                </span>
                <svg
                  width="16"
                  height="19"
                  viewBox="0 0 16 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0.537842 15.7791V16.3932C2.58481 18.0316 5.17851 19.0002 8.0035 19.0002C10.8285 19.0002 13.4222 18.0316 15.4621 16.3932V15.7791C15.4621 9.19334 0.537842 9.19334 0.537842 15.7791Z"
                    fill="#64748B"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.0035 0.45874C5.49221 0.45874 3.45853 2.49241 3.45853 5.0046C3.45853 7.51501 5.49221 9.54868 8.0035 9.54868C10.5077 9.54868 12.5414 7.51501 12.5414 5.0046C12.5414 2.49241 10.5077 0.45874 8.0035 0.45874Z"
                    fill="#64748B"
                  />
                </svg>
              </div>
            </div>
          </header>
          {dropdownOpen && (
            <div className="flex w-full justify-end">
              <NotificationDropdown
                setDropdownOpen={setDropdownOpen}
                ignoreRef={bellRef}
              />
            </div>
          )}
        </>
      )}
    </>
  );
};

export default Header;
